import {
    SchedulableInvoiceLine,
    getSchedulableInvoiceAmount,
} from "@common/helpers/domains/accounting/invoiceScheduleLines";
import { resolveInvoiceSourceDate } from "@common/helpers/domains/accounting/invoiceSourceDate";
import { isInvoiceItemLine } from "@common/helpers/lineItems";
import { Invoice } from "@common/types/invoice";

export function deriveInvoiceTermStart(invoice: Invoice): string {
    return resolveInvoiceSourceDate(invoice);
}

/**
 * The amount a new invoice schedule defaults to. Without loaded lines there is
 * nothing to net, so the caller's document or line amount stands in.
 */
export function getInvoiceScheduleAmount(options: {
    lines: readonly SchedulableInvoiceLine[] | undefined;
    sourceLineIds?: readonly string[];
    fallbackAmount: number;
}): number {
    if (!options.lines?.length) {
        return Math.abs(options.fallbackAmount);
    }
    return getSchedulableInvoiceAmount({
        lines: options.lines,
        sourceLineIds: options.sourceLineIds,
    });
}

/** The lines a user can scope a schedule to; their discounts follow them. */
export function getSchedulableInvoiceItemLines<
    T extends SchedulableInvoiceLine,
>(lines: readonly T[]): T[] {
    return lines.filter((line) => isInvoiceItemLine(line));
}
